import { useRoutes, Navigate } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import Layout from '@/components/feature/Layout'
import HomeModern from '@/pages/home/HomeModern'
import ServersPage from '@/pages/ServersPage'
import ModsPage from '@/pages/ModsPage'
import JoinPage from '@/pages/JoinPage'
import RulesPage from '@/pages/RulesPage'
import GalleryPage from '@/pages/GalleryPage'
import StatsPage from '@/pages/StatsPage'
import NewsPage from '@/pages/NewsPage'
import NewsDetailPage from '@/pages/NewsDetailPage'
import NotFound from '@/pages/NotFound'

const routes: RouteObject[] = [
  // Home renders its own full-page chrome (nav + footer).
  { path: '/', element: <HomeModern /> },
  // Legacy preview route → home (blocky style retired).
  { path: '/blocky', element: <Navigate to="/" replace /> },

  // Inner pages share the standard Layout (nav + footer via <Outlet/>).
  {
    element: <Layout />,
    children: [
      { path: '/servers', element: <ServersPage /> },
      { path: '/mods', element: <ModsPage /> },
      { path: '/join', element: <JoinPage /> },
      { path: '/rules', element: <RulesPage /> },
      { path: '/gallery', element: <GalleryPage /> },
      { path: '/stats', element: <StatsPage /> },
      { path: '/news', element: <NewsPage /> },
      { path: '/news/:id', element: <NewsDetailPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]

export function AppRoutes() {
  return useRoutes(routes)
}

export default routes
